import { render, staticRenderFns } from "./periodic.vue?vue&type=template&id=5e81d144&scoped=true"
import script from "./periodic.vue?vue&type=script&setup=true&lang=ts"
export * from "./periodic.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./periodic.vue?vue&type=style&index=0&id=5e81d144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81d144",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/Question.vue').default,IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxSurveyQuestionGroup: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/QuestionGroup.vue').default,IxDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Dialog.vue').default,IxSectionOrQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionOrQuestion.vue').default})
